// Secondary language 'en' marks an English-only destination (e.g. Australia, UK,
// US) — announcements play in English with no second track. Mirrors
// isEnglishOnly() in backend/services/translationService.js.
export function isEnglishOnly(code) {
  return code === 'en' || /^en-/.test(code || '');
}

// "EN + ko-KR" / "EN + KO" (short) / "EN only"
export function languagePairLabel(code, { short = false, fallback = 'zh-CN' } = {}) {
  const lang = code || fallback;
  if (!lang) return 'EN';
  if (isEnglishOnly(lang)) return 'EN only';
  return `EN + ${short ? lang.split('-')[0].toUpperCase() : lang}`;
}
